import {
  KubernetesNetworkSecurityTypeSpecificData,
  NetworkSecurityPolicyPayload,
  NetworkSecurityRule,
  NetworkSecurityRulePayload,
} from './types';

/**
 * Builds the API payload from form data
 */
export function buildKubernetesNetworkSecurityPayload(
  formData: KubernetesNetworkSecurityTypeSpecificData
): NetworkSecurityPolicyPayload {
  const namespaces = formData.namespaces.map((item) => item.namespace.trim());

  const ingressRules = formData.ingressRules.map((rule) =>
    buildNetworkRulesPayload(rule, namespaces)
  );
  const egressRules = formData.egressRules.map((rule) =>
    buildNetworkRulesPayload(rule, namespaces)
  );

  return {
    ingressRules: ingressRules,
    egressRules: egressRules,
  };
}

function buildNetworkRulesPayload(
  rule: NetworkSecurityRule,
  namespaces: string[]
): NetworkSecurityRulePayload {
  const appliesTo =
    rule.appliesTo === undefined
      ? undefined
      : {
          type: rule.appliesTo.type,
          namespaces: namespaces,
          matchLabels: rule.appliesTo.matchLabels,
          matchExpressions: rule.appliesTo.matchExpressions,
        };

  return {
    name: rule.name,
    appliesTo: appliesTo,
    sourceType: rule.sourceType,
    namespace: rule.namespace,
    podLabels: rule.podLabels,
    cidr: rule.cidr,
    port: rule.port,
    protocol: rule.protocol,
  };
}
